import styled from 'styled-components';

import { media } from 'utils/detection';
import withParallax from 'utils/parallax';

export default withParallax(styled.p`
  color: ${props => props.theme.textSemiDark};
  font-family: 'Galano Classic';
  font-size: 27px;
  font-weight: 400;
  padding: 0;
  margin: 0;

  ${media.medium`
    font-size: 2.5vw;
  `}
`);
